import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button } from '#app/shared/ui/inputs/button/Button.js'
import { Checkbox } from '#app/shared/ui/inputs/Checkbox.js'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'

interface FilterModeloProps {
  onActivate: () => void
  buttonRef: React.RefObject<HTMLButtonElement>
  modelCountsByBrand: Record<string, Record<string, number>>
}

export const FilterModelo: React.FC<FilterModeloProps> = ({
  onActivate,
  buttonRef,
  modelCountsByBrand,
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [filteredBrands, setFilteredBrands] = useState<string[]>([])

  const updateFilteredBrands = () => {
    const brands = searchParams.get('brands')
    if (brands) {
      const brandsArray = brands.split(',')
      setFilteredBrands(brandsArray)
    } else {
      setFilteredBrands([])
    }
  }

  useEffect(() => {
    updateFilteredBrands()

    const handlePopState = () => {
      updateFilteredBrands()
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [searchParams])

  const handleCheckboxChange = (model: string, checked: boolean) => {
    const currentModels = searchParams.get('models')?.split(',') || []
    let updatedModels

    if (checked) {
      updatedModels = [...currentModels, model]
    } else {
      updatedModels = currentModels.filter((m: string) => m !== model)
    }

    const newParams = new URLSearchParams(searchParams.toString())
    newParams.set('models', updatedModels.join(','))

    setSearchParams(newParams)
  }

  const modelCounts: Record<string, number> = {}
  for (const brandName of filteredBrands) {
    const brandModels = modelCountsByBrand[brandName]
    if (!brandModels) continue
    for (const [model, count] of Object.entries(brandModels)) {
      modelCounts[model] = (modelCounts[model] ?? 0) + count
    }
  }

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onActivate()
  }

  return (
    <MainContainer>
      <div className="my-3 flex w-full flex-col">
        {Object.entries(modelCounts).length === 0 ? (
          <div className="flex flex-col items-center">
            <h4
              className={`
                text-center text-h4

                sm:block sm:text-left
              `}
            >
              <span
                className={`
                  block

                  sm:inline
                `}
              >
                Selecciona una marca{' '}
              </span>
              <span
                className={`
                  block

                  sm:inline
                `}
              >
                para ver los modelos
              </span>
            </h4>
            <Button
              ref={buttonRef}
              className={`
                mt-6 w-auto border-neutral-100 bg-white p-3 pb-3 pl-4 pr-4
                text-subtitle1-bold
              `}
              onClick={(e) => {
                e.stopPropagation()
                handleButtonClick(e)
              }}
            >
              Seleccionar marca
            </Button>
          </div>
        ) : (
          <div className="flex w-full flex-col items-start">
            <p className="mb-5 text-left text-base-bold">Modelos disponibles</p>
            <div
              className={`
                flex flex-wrap gap-5

                sm:flex-row sm:flex-wrap
              `}
            >
              {Object.entries(modelCounts).map(([model, count]) => (
                <div
                  key={model}
                  className={`
                    mb-2 flex w-full items-center text-base-medium
                    text-neutral-700

                    sm:w-auto
                  `}
                >
                  <Checkbox
                    id={model}
                    checked={
                      searchParams.get('models')?.split(',').includes(model) ??
                      false
                    }
                    onCheckedChange={(checked) =>
                      handleCheckboxChange(model, !!checked)
                    }
                  />
                  <span className="ml-2">
                    {model} ({count})
                  </span>
                </div>
              ))}
            </div>
            <p className="mt-6 text-base-medium text-neutral-700">
              ¿No ves tu modelo aquí?
              <span className="text-primary-600 underline">
                {' '}
                Encarga tu coche ideal y lo buscamos para ti en toda Europa, al
                mejor precio.
              </span>
            </p>
          </div>
        )}
      </div>
    </MainContainer>
  )
}
